<template>
    <v-content>
      <v-container fluid>
        <h1 class="py-3">Account</h1>
        <v-alert v-if="error" :value="true" type="error">{{ error }}</v-alert>
        <UserList
          v-on:error="errorHandler"/>
      </v-container>
    </v-content>
</template>
<script>
import UserList from './UserList'
export default {
  name: 'Account',
  components: { UserList },
  data: () => ({
    error: false
  }),
  methods: {
    errorHandler (error) {
      this.error = error
    }
  }
}
</script>
